import { render, staticRenderFns } from "./form-grupo-quimico.vue?vue&type=template&id=4e9fa808&"
import script from "./form-grupo-quimico.vue?vue&type=script&lang=js&"
export * from "./form-grupo-quimico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports